module.exports = __webpack_public_path__ + "media/images/home_white-d2cdf91fd9d2762564750226dc311e3a.svg";